import { useEffect, useState } from "react";
import { getCurrentUserInfo } from "../../auth/getCurrentUserInfo";
import { allBadges, getBadgeDetails } from "./BadgeData";
import TitleBar from "../TitleBar";
import BadgeRow from "./BadgeRow";
import BadgePopup from "./BadgePopup";
import { CircularProgress, Divider } from "@material-ui/core";
import PointsBar from "../Profile/PointsBar";
import { Wrapper } from "../base/Wrapper";
import { getGermanDate } from "../../lib/utilities";
import { getFollowing } from "../../auth/getFollowerData";
import { getCurrentUser } from "../../auth/getCurrentUser";

function Badges(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [userInfo, setUserInfo] = useState({});
  const [open, setOpen] = useState(false);
  const [popupID, setPopupID] = useState(null);
  const [achievedFollowings, setAchievedFollowings] = useState([]);

  useEffect(() => {
    const loadUserInfo = async () => {
      const userInfo = await getCurrentUserInfo();
      const currentUser = getCurrentUser();
      const followingArr = await getFollowing(currentUser.id);

      if (userInfo) {
        setUserInfo(userInfo);
        setAchievedFollowings(followingArr);
        setIsLoading(false);
      }
    };
    loadUserInfo();
  }, []);

  if (isLoading) {
    return (
      <div style={{ textAlign: "center", marginTop: "45vh" }}>
        <CircularProgress />
      </div>
    );
  }

  const {
    badges = [],
    streak: achievedStreak,
    completedTrail: achievedAllStations,
    givenLikes: achievedLikes,
    verifiedWorkouts: achievedVerifiedWorkouts,
    allWorkouts: achievedWorkouts,
    sumTime: achievedSumTime,
  } = userInfo;

  const badgeCount = Object.keys(allBadges.filter((el) => el.title)).length;

  const handlePopupID = (ID) => {
    setPopupID(ID);
  };

  function getBadgeRowData(ID) {
    return allBadges.filter(function (obj) {
      return obj.id.toString().charAt(0) === ID.toString();
    });
  }

  function getBadgeData(ID) {
    return allBadges.find((el) => el.id === ID);
  }

  function countAchieved(ID) {
    const badgeName = getBadgeDetails(ID).name;
    let count = 0;
    try {
      Object.keys(badges).forEach((key) => {
        if (key.includes(badgeName)) count++;
      });
    } catch {}
    return count;
  }

  function getAchievedDate(popupID) {
    const badgeName = getBadgeDetails(popupID).name;
    let badgeAmount = getBadgeData(popupID).amount;
    if (Number(popupID.toString().charAt(0)) === 3) {
      badgeAmount = badgeAmount * 60; // badge sumTime uses seconds in name
    }
    const entry = badgeName + "-" + badgeAmount;
    if (badges[entry]) {
      return getGermanDate(badges[entry]);
    } else {
      return null;
    }
  }

  function getAchievedProgress(popupID) {
    const badgeName = getBadgeDetails(popupID).name;
    function getPercentage(badgeName) {
      try {
        switch (badgeName) {
          case "streak":
            return (achievedStreak.daysInARow / getBadgeData(popupID).days) * 100;
          case "completedTrail":
            return (achievedAllStations.numberOfCompletions / getBadgeData(popupID).amount) * 100;
          case "followings":
            return (achievedFollowings.length / getBadgeData(popupID).amount) * 100;
          case "likes":
            return (achievedLikes / getBadgeData(popupID).amount) * 100;
          case "verifiedWorkouts":
            return (achievedVerifiedWorkouts / getBadgeData(popupID).amount) * 100;
          case "allWorkouts":
            return (achievedWorkouts / getBadgeData(popupID).amount) * 100;
          case "sumTime":
            return (achievedSumTime / getBadgeData(popupID).min / 60) * 100;
          default:
            console.error("Badge unknown, can't get progress information.");
        }
      } catch {
        return 0;
      }
    }
    const percentageValue = getPercentage(badgeName);
    if (!isNaN(percentageValue)) {
      return percentageValue;
    } else {
      return 0;
    }
  }

  return (
    <>
      {popupID && (
        <BadgePopup
          open={open}
          close={() => setOpen(false)}
          badgeDetails={getBadgeDetails(popupID)}
          badgeData={getBadgeData(popupID)}
          progress={getAchievedProgress(popupID)}
          achieved={getAchievedDate(popupID)}
        />
      )}
      <div style={{ paddingBottom: "4rem" }}>
        <TitleBar title="Erfolge" navigateTo="/profile" colorPrimary />
        <Wrapper withoutPB>
          <PointsBar
            sumTime={userInfo.sumTime ? userInfo.sumTime : 0}
            loading={isLoading}
            openTrue={props.location?.state?.openInfo}
            outlined
            info
          />
        </Wrapper>
        <Divider />
        {[...Array(badgeCount)].map((item, i) => (
          <BadgeRow
            key={i}
            open={() => setOpen(true)}
            handlePopupID={handlePopupID}
            title={getBadgeDetails(i + 1).title}
            description={getBadgeDetails(i + 1).description}
            icon={getBadgeDetails(i + 1).icon}
            color={getBadgeDetails(i + 1).color}
            badgeType={getBadgeDetails(i + 1).badgeType}
            badgeUnits={getBadgeRowData(i + 1)}
            achieved={countAchieved(i + 1)}
            noDivider={badgeCount === i + 1 ? true : false}
          />
        ))}
      </div>
    </>
  );
}

export default Badges;
